import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLang } from './helpers'
import qs from 'qs';

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

let query = qs.parse(window.location.search.slice(1));

let lang = query.lang;

switchI18nLang(lang);

function switchI18nLang (lang) {
  if (!lang) {
    return
  }

  if (lang === 'zh_CN') {
    localStorage.setItem('locale', 'zh');
    return
  }

  if (lang === 'ko_KR') {
    localStorage.setItem('locale', 'ko');
    return
  }

  if (lang === 'ja_JP') {
    localStorage.setItem('locale', 'ja');
    return
  }

  localStorage.setItem('locale', 'en');
}

export default new VueI18n({
  locale: getLang(),
  fallbackLocale: 'zh',
  messages: loadLocaleMessages()
})
